import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import rolePermissionService from "../../../services/rolePermissionService";

const Sidebar = () => {
  const [menuname, setMenuName] = useState(true);
  const [showChildMenu, setshowChildMenu] = useState(false);
  const [menuactive, setMenuActive] = useState("1");
  const [homemenu, setHomeMenu] = useState("");
  const [hideshow, setHideShow] = useState("true");
  const location = useLocation();
  const [permissionArray, setPermissionArray] = useState([]);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    const activemenu = localStorage.getItem("menuactive")
      ? localStorage.getItem("menuactive")
      : menuactive;
    const childmenu = localStorage.getItem("child")
      ? localStorage.getItem("child")
      : showChildMenu;
    const homemenus = localStorage.getItem("home")
      ? localStorage.getItem("home")
      : homemenu;
    setMenuActive(activemenu);
    setHomeMenu(homemenus);
    if (childmenu === "false") {
      setshowChildMenu(false);
    } else {
      setshowChildMenu(true);
    }
  }, []);

  useEffect(() => {
    const showhide = localStorage.getItem("hideshow")
      ? localStorage.getItem("hideshow")
      : hideshow;
    if (showhide === "true") {
      showSideBar();
      setHomeMenu("true");
    } else {
      hideSideBar();
    }

    document.addEventListener("DOMContentLoaded", function () {
      const menuItems = document.querySelectorAll(".li-style");

      menuItems.forEach(function (item) {
        const submenu = item.querySelector(".parent");

        item.addEventListener("mouseenter", function () {
          submenu.style.display = "block";
          item.classList.add("opened");
        });

        item.addEventListener("mouseleave", function () {
          submenu.style.display = "none";
          item.classList.remove("opened");
        });
      });
    });
  }, []);

  const fetchPermission = async () => {
    const token = localStorage.getItem("token");

    await rolePermissionService
      .allPermissions(token)
      .then((res) => {
        setPermissionArray(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchPermission();
  }, []);

  /// hide side bar on click
  const hideSideBar = () => {
    document.getElementById("sidebar").style.width = "100px";
    document.getElementById("viewport").style.paddingLeft = "100px";
    setMenuName(false);
    localStorage.setItem("hideshow", false);
  };

  // show side bar on click
  const showSideBar = () => {
    document.getElementById("sidebar").style.width = "228px";
    document.getElementById("viewport").style.paddingLeft = "228px";
    setMenuName(true);
    localStorage.setItem("hideshow", true);
  };

  const activeClass = (route) => {

    if (typeof route === "string") {
      if (location.pathname === route) {
        return menuname ? "active" : "div-toggle-active";
      }
    }

    if (typeof route === "object") {
      let classType = menuname ? "" : "div-toggle";
      route.map((r) => {
        const pathSegments = location.pathname.split("/");
        const second = r.split("/");
        const secondurl = second[1];
        const targetSegment = pathSegments[1];

        if (targetSegment === secondurl) {
          classType = menuname ? "active" : "div-toggle-active";
        }
      });

      return classType;
    }

    return menuname ? "" : "div-toggle";
  };

  const handleMenuActive = (menuactive) => {
    // alert(menuactive)
    if (
      menuactive === 3 ||
      menuactive === 4 ||
      menuactive === 5 ||
      menuactive === 6
    ) {
      localStorage.setItem("child", true);
    } else {
      localStorage.setItem("child", false);
    }
    localStorage.setItem("menuactive", menuactive);
    if (menuactive === 1) {
      localStorage.setItem("home", true);
    } else {
      localStorage.setItem("home", false);
    }
  };

  const handleChildMenu = () => {
    setshowChildMenu((prevState) => !prevState);
    localStorage.setItem("child", !showChildMenu);
    localStorage.setItem("menuactive", 3);
  };

  const itemActive = (item) => {
      
      setActiveItem(item.id); 
    
  };

  const sidebarItems = [
    {
      name: "Dashboard",
      value: "dashboard",
      className: activeClass(["/dashboard"]),
      icon: (isActive) => (
        <img
          src={`../admin/home-${isActive ? "blue" : "white"}.svg`}
          alt="no images"
          width={18}
          height={18}
        />
      ),
      url: "/dashboard",
      id: 1,
      submenu: [],
    },
    {
      name: "Portfolios",
      value: "portfolio",
      className: activeClass([
        "/admin-portfolios",
        "/add-portfolio",
        "/edit-portfolio/",
        "/add-portfolioDetails",
        "/edit-portfolioDetails",
      ]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_3679_9359)">
            <path
              d="M4.95198 6.01654H14.2195V5.43723C14.2195 4.95911 13.8279 4.56826 13.3505 4.56826H9.52549V4.06232C9.52549 3.34243 8.93998 2.75925 8.22241 2.75925H5.99784C5.65024 2.75925 5.32353 2.89518 5.07634 3.14236C4.82915 3.38955 4.69398 3.71394 4.69398 4.06232V4.56902H0.868968C0.390851 4.56826 0 4.95908 0 5.43723V13.1978L2.9213 7.27948C3.27585 6.55876 4.15022 6.01654 4.95198 6.01654ZM5.56298 4.06232C5.56298 3.94723 5.6101 3.8383 5.69121 3.75645C5.73092 3.71551 5.77847 3.68299 5.83102 3.66083C5.88358 3.63867 5.94005 3.62732 5.99709 3.62746H8.22166C8.4619 3.62746 8.65577 3.82212 8.65577 4.06232V4.56902H5.56302V4.06232H5.56298Z"
              fill={isActive ? "#1F4168" : "white"} // Conditional color for the first path
            />
            <path
              d="M17.4343 6.88397H4.95197C4.4746 6.88397 3.90997 7.23465 3.70063 7.66256L0.343717 14.4629C0.132088 14.8901 0.350664 15.2408 0.828029 15.2408H13.3103C13.7877 15.2408 14.3531 14.8909 14.5632 14.4629L17.9194 7.66256C18.1302 7.23465 17.9132 6.88397 17.4343 6.88397Z"
              fill={isActive ? "#1F4168" : "white"} // Conditional color for the second path
            />
          </g>
          <defs>
            <clipPath id="clip0_3679_9359">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),

      url: "/admin-portfolios",
      id: 2,
      submenu: [],
    },
    {
      name: "Upload File",
      value: "upload_file",
      className: activeClass(["/upload-file"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4.5 1.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.675 16.5 4.5 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5H4.5ZM9.75 6.75V2.625L13.875 6.75H9.75Z"
            fill={isActive ? "#1F4168" : "white"}
          />
        </svg>
      ),
      url: "/upload-file",
      id: 16,
      submenu: [],
    },
    {
      name: "Jobs",
      value: "jobs",
      className: activeClass(["parent"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_3679_9368)">
            <path
              d="M11.25 4.875C11.0511 4.875 10.8603 4.79598 10.7197 4.65533C10.579 4.51468 10.5 4.32391 10.5 4.125V3H7.5V4.125C7.5 4.32391 7.42098 4.51468 7.28033 4.65533C7.13968 4.79598 6.94891 4.875 6.75 4.875C6.55109 4.875 6.36032 4.79598 6.21967 4.65533C6.07902 4.51468 6 4.32391 6 4.125V3C6 2.17275 6.67275 1.5 7.5 1.5H10.5C11.3273 1.5 12 2.17275 12 3V4.125C12 4.32391 11.921 4.51468 11.7803 4.65533C11.6397 4.79598 11.4489 4.875 11.25 4.875ZM9.5325 11.535C9.17196 11.6589 8.77956 11.6536 8.4225 11.52L0 8.715V14.4375C0 15.5775 0.9225 16.5 2.0625 16.5H15.9375C17.0775 16.5 18 15.5775 18 14.4375V8.715L9.5325 11.535Z"
              fill={isActive ? "white" : "white"}
            />
            <path
              d="M18 5.8125V7.53L9.18 10.47C9.12 10.4925 9.06 10.5 9 10.5C8.94 10.5 8.88 10.4925 8.82 10.47L0 7.53V5.8125C0 4.6725 0.9225 3.75 2.0625 3.75H15.9375C17.0775 3.75 18 4.6725 18 5.8125Z"
              fill={isActive ? "white" : "white"}
            />
          </g>
          <defs>
            <clipPath id="clip0_3679_9368">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      url: "/job-list",
      id: 3,
      submenu: [
        {
          name: "Job List",
          value: "job_list",
          icon: (id)=>(
            <svg
              width="18"
              height="18"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M442.24 30H384.39V65C384.39 89.81 364.2 110 339.39 110H172.61C147.8 110 127.61 89.81 127.61 65V30H69.7598C61.4798 30 54.7598 36.72 54.7598 45V497C54.7598 505.28 61.4798 512 69.7598 512H442.24C450.52 512 457.24 505.28 457.24 497V45C457.24 36.72 450.52 30 442.24 30ZM284.543 426.136H129.755C121.471 426.136 114.755 419.42 114.755 411.136C114.755 402.852 121.471 396.136 129.755 396.136H284.543C292.827 396.136 299.543 402.852 299.543 411.136C299.543 419.42 292.827 426.136 284.543 426.136ZM284.543 320.136H129.755C121.471 320.136 114.755 313.42 114.755 305.136C114.755 296.852 121.471 290.136 129.755 290.136H284.543C292.827 290.136 299.543 296.852 299.543 305.136C299.543 313.42 292.827 320.136 284.543 320.136ZM284.543 213.136H129.755C121.471 213.136 114.755 206.42 114.755 198.136C114.755 189.852 121.471 183.136 129.755 183.136H284.543C292.827 183.136 299.543 189.852 299.543 198.136C299.543 206.42 292.827 213.136 284.543 213.136ZM392.851 423.665C398.709 429.523 398.709 439.02 392.851 444.878C386.993 450.737 377.495 450.736 371.638 444.878L359.109 432.349L346.58 444.878C340.722 450.737 331.224 450.736 325.367 444.878C319.509 439.02 319.509 429.523 325.367 423.665L337.896 411.136L325.367 398.607C319.509 392.749 319.509 383.252 325.367 377.394C331.224 371.536 340.722 371.536 346.58 377.394C352.438 383.252 352.438 392.749 346.58 398.607L359.109 411.136L392.851 423.665ZM392.851 317.665C398.709 323.523 398.709 333.02 392.851 338.878C386.993 344.737 377.495 344.736 371.638 338.878L359.109 326.349L346.58 338.878C340.722 344.737 331.224 344.736 325.367 338.878C319.509 333.02 319.509 323.523 325.367 317.665L337.896 305.136L325.367 292.607C319.509 286.749 319.509 277.252 325.367 271.394C331.224 265.536 340.722 265.536 346.58 271.394C352.438 277.252 352.438 286.749 346.58 292.607L359.109 305.136L392.851 317.665ZM392.851 210.665C398.709 216.523 398.709 226.02 392.851 231.878C386.993 237.737 377.495 237.736 371.638 231.878L359.109 219.349L346.58 231.878C340.722 237.737 331.224 237.736 325.367 231.878C319.509 226.02 319.509 216.523 325.367 210.665L337.896 198.136L325.367 185.607C319.509 179.749 319.509 170.252 325.367 164.394C331.224 158.536 340.722 158.536 346.58 164.394C352.438 170.252 352.438 179.749 346.58 185.607L359.109 198.136L392.851 210.665Z"
                fill={activeItem === id ? "#1F4168" : "white"} 
              />
              <path
                d="M354.389 15V65C354.389 73.28 347.669 80 339.389 80H172.609C164.329 80 157.609 73.28 157.609 65V15C157.609 6.72 164.329 0 172.609 0H339.389C347.669 0 354.389 6.72 354.389 15Z"
                fill={activeItem === id ? "#1F4168" : "white"} 
              />
            </svg>
          ),
          url: "/job-list",
          className: activeClass(["/job-list", "/add-job", "/edit-job"]),
          id: 4,
        },
        {
          name: "Job Title List",
          value: "job_title_list",
          className: activeClass(["/job-title-list", "/add-job-title"]),

          icon: (id)=>(
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <g clipPath="url(#clip0_3679_9368)">
                <path
                  d="M11.25 4.875C11.0511 4.875 10.8603 4.79598 10.7197 4.65533C10.579 4.51468 10.5 4.32391 10.5 4.125V3H7.5V4.125C7.5 4.32391 7.42098 4.51468 7.28033 4.65533C7.13968 4.79598 6.94891 4.875 6.75 4.875C6.55109 4.875 6.36032 4.79598 6.21967 4.65533C6.07902 4.51468 6 4.32391 6 4.125V3C6 2.17275 6.67275 1.5 7.5 1.5H10.5C11.3273 1.5 12 2.17275 12 3V4.125C12 4.32391 11.921 4.51468 11.7803 4.65533C11.6397 4.79598 11.4489 4.875 11.25 4.875ZM9.5325 11.535C9.17196 11.6589 8.77956 11.6536 8.4225 11.52L0 8.715V14.4375C0 15.5775 0.9225 16.5 2.0625 16.5H15.9375C17.0775 16.5 18 15.5775 18 14.4375V8.715L9.5325 11.535Z"
                  fill={activeItem === id ? "#1F4168" : "white"}
                />
                <path
                  d="M18 5.8125V7.53L9.18 10.47C9.12 10.4925 9.06 10.5 9 10.5C8.94 10.5 8.88 10.4925 8.82 10.47L0 7.53V5.8125C0 4.6725 0.9225 3.75 2.0625 3.75H15.9375C17.0775 3.75 18 4.6725 18 5.8125Z"
                  fill={activeItem === id ? "#1F4168" : "white"}
                />
              </g>
              <defs>
                <clipPath id="clip0_3679_9368">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ),
          url: "/job-title-list",
          id: 5,
        },
        {
          name: "Archived Jobs",
          value: "archived_jobs",
          className: activeClass(["/job-archive"]),
          icon: (id)=>(
            <svg
              width="18"
              height="18"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4555_3077)">
                <mask
                  id="mask0_4555_3077"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="512"
                  height="512"
                >
                  <path d="M512 0H0V512H512V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_4555_3077)">
                  <path
                    d="M497.778 62.5778L457.956 14.2222C452.267 5.68889 440.889 0 426.667 0H85.3333C71.1111 0 59.7333 5.68889 51.2 14.2222L14.2222 62.5778C5.68889 73.9556 0 85.3333 0 99.5556V455.111C0 486.4 25.6 512 56.8889 512H455.111C486.4 512 512 486.4 512 455.111V99.5556C512 85.3333 506.311 73.9556 497.778 62.5778ZM256 412.444L99.5556 256H199.111V199.111H312.889V256H412.444L256 412.444ZM59.7333 56.8889L82.4889 28.4444H423.822L449.422 56.8889H59.7333Z"
                    fill={activeItem === id ? "#1F4168" : "#FFFFFF"} 
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_4555_3077">
                  <rect width="512" height="512" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ),

          url: "/job-archive",
          id: 6,
        },
      ],
    },
    {
      name: "Clients Review",
      value: "client_review",
      className: activeClass(["/review-list", "/add-review", "/edit-review"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3 5.25C3 4.25544 3.39509 3.30161 4.09835 2.59835C4.80161 1.89509 5.75544 1.5 6.75 1.5C7.74456 1.5 8.69839 1.89509 9.40165 2.59835C10.1049 3.30161 10.5 4.25544 10.5 5.25C10.5 6.24456 10.1049 7.19839 9.40165 7.90165C8.69839 8.60491 7.74456 9 6.75 9C5.75544 9 4.80161 8.60491 4.09835 7.90165C3.39509 7.19839 3 6.24456 3 5.25ZM10.9875 8.349C10.7955 8.6115 10.9245 9 11.25 9C12.2446 9 13.1984 8.60491 13.9017 7.90165C14.6049 7.19839 15 6.24456 15 5.25C15 4.25544 14.6049 3.30161 13.9017 2.59835C13.1984 1.89509 12.2446 1.5 11.25 1.5C10.9245 1.5 10.7955 1.88775 10.9875 2.151C11.625 3.0195 12 4.0905 12 5.25C12 6.4095 11.625 7.4805 10.9875 8.349ZM15 16.5C14.8011 16.5 14.6103 16.421 14.4697 16.2803C14.329 16.1397 14.25 15.9489 14.25 15.75V14.25C14.25 13.125 13.8795 12.0218 13.215 11.1225C13.0358 10.8795 13.1978 10.5 13.5 10.5C13.9925 10.5 14.4801 10.597 14.9351 10.7855C15.39 10.9739 15.8034 11.2501 16.1517 11.5984C16.4999 11.9466 16.7761 12.36 16.9645 12.8149C17.153 13.2699 17.25 13.7575 17.25 14.25V15.75C17.25 15.9489 17.171 16.1397 17.0303 16.2803C16.8897 16.421 16.6989 16.5 16.5 16.5H15ZM1.848 11.598C2.19629 11.2498 2.60976 10.9736 3.06479 10.7852C3.51982 10.5968 4.00751 10.4999 4.5 10.5H9C9.99456 10.5 10.9484 10.8951 11.6517 11.5984C12.3549 12.3016 12.75 13.2554 12.75 14.25V15.75C12.75 15.9489 12.671 16.1397 12.5303 16.2803C12.3897 16.421 12.1989 16.5 12 16.5H1.5C1.30109 16.5 1.11032 16.421 0.96967 16.2803C0.829018 16.1397 0.75 15.9489 0.75 15.75V14.25C0.750013 13.2556 1.14496 12.302 1.848 11.5988V11.598Z"
            fill={isActive ? "#1F4168" : "white"}
          />
        </svg>
      ),

      url: "/review-list",
      id: 7,
      submenu: [],
    },
    {
      name: "Technologies",
      value: "technologies",
      className: activeClass([
        "/technology-list",
        "/add-technology",
        "/edit-technology",
      ]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_4340_7005)">
            <path
              d="M7.73242 7.73227H10.2679V10.2677H7.73242V7.73227Z"
              fill={isActive ? "#1F4168" : "white"}
            />
            <path
              d="M16.418 9.52734C15.7306 9.52734 15.1444 9.96831 14.9267 10.582H13.7812V7.41797H14.9267C15.1444 8.03169 15.7306 8.47266 16.418 8.47266C17.2902 8.47266 18 7.76285 18 6.89062C18 6.0184 17.2902 5.30859 16.418 5.30859C15.7306 5.30859 15.1444 5.74956 14.9267 6.36328H13.7812V4.74609C13.7812 4.455 13.545 4.21875 13.2539 4.21875H10.582V2.10938H12.2604C12.4781 2.7231 13.0643 3.16406 13.7517 3.16406C14.6243 3.16406 15.3337 2.45426 15.3337 1.58203C15.3337 0.709805 14.6243 0 13.7517 0C13.0643 0 12.4781 0.440965 12.2604 1.05469H10.0547C9.76345 1.05469 9.52734 1.2908 9.52734 1.58203V4.21875H8.47266V1.58203C8.47266 1.2908 8.23655 1.05469 7.94531 1.05469H5.73957C5.52185 0.440965 4.93566 0 4.24828 0C3.3757 0 2.66625 0.709805 2.66625 1.58203C2.66625 2.45426 3.3757 3.16406 4.24828 3.16406C4.93566 3.16406 5.52185 2.7231 5.73957 2.10938H7.41797V4.21875H4.74609C4.455 4.21875 4.21875 4.455 4.21875 4.74609V6.36328H3.07332C2.8556 5.74956 2.26941 5.30859 1.58203 5.30859C0.709805 5.30859 0 6.0184 0 6.89062C0 7.76285 0.709805 8.47266 1.58203 8.47266C2.26941 8.47266 2.8556 8.03169 3.07332 7.41797H4.21875V10.582H3.07332C2.8556 9.96831 2.26941 9.52734 1.58203 9.52734C0.709805 9.52734 0 10.2371 0 11.1094C0 11.9816 0.709805 12.6914 1.58203 12.6914C2.26941 12.6914 2.8556 12.2504 3.07332 11.6367H4.21875V13.2539C4.21875 13.545 4.455 13.7812 4.74609 13.7812H7.41797V15.8906H5.73957C5.52185 15.2769 4.93566 14.8359 4.24828 14.8359C3.3757 14.8359 2.66625 15.5457 2.66625 16.418C2.66625 17.2902 3.3757 18 4.24828 18C4.93566 18 5.52185 17.559 5.73957 16.9453H7.94531C8.23655 16.9453 8.47266 16.7092 8.47266 16.418V13.7812H9.52734V16.418C9.52734 16.7092 9.76345 16.9453 10.0547 16.9453H12.2604C12.4781 17.559 13.0643 18 13.7517 18C14.6243 18 15.3337 17.2902 15.3337 16.418C15.3337 15.5457 14.6243 14.8359 13.7517 14.8359C13.0643 14.8359 12.4781 15.2769 12.2604 15.8906H10.582V13.7812H13.2539C13.545 13.7812 13.7812 13.545 13.7812 13.2539V11.6367H14.9267C15.1444 12.2504 15.7306 12.6914 16.418 12.6914C17.2902 12.6914 18 11.9816 18 11.1094C18 10.2371 17.2902 9.52734 16.418 9.52734Z"
              fill={isActive ? "#1F4168" : "white"}
            />
          </g>
          <defs>
            <clipPath id="clip0_4340_7005">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),

      url: "/technology-list",
      id: 8,
      submenu: [],
    },
    {
      name: "Services",
      value: "services",
      className: activeClass([
        "/service-list",
        "/add-service",
        "/edit-service",
      ]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M11.25 14.6166C10.9642 14.7313 10.6689 14.8275 10.3635 14.8978L10.2397 16.5099C10.2321 16.6093 10.1872 16.7021 10.1141 16.7697C10.041 16.8374 9.94506 16.875 9.84544 16.875H8.154C8.05452 16.875 7.95871 16.8375 7.88571 16.7699C7.81271 16.7023 7.7679 16.6097 7.76025 16.5105L7.6365 14.8984C6.9843 14.748 6.36183 14.4897 5.79488 14.1339L4.56581 15.1875C4.49022 15.2523 4.39293 15.2862 4.29342 15.2824C4.19391 15.2785 4.09953 15.2372 4.02919 15.1667L2.83331 13.9708C2.76293 13.9004 2.7217 13.806 2.71784 13.7066C2.71398 13.6071 2.74779 13.5098 2.8125 13.4342L3.86606 12.2051C3.51082 11.6379 3.25247 11.0155 3.10162 10.3635L1.4895 10.2397C1.39027 10.232 1.29762 10.187 1.23006 10.1139C1.16249 10.0409 1.12498 9.94497 1.125 9.84544V8.154C1.125 7.94756 1.28419 7.776 1.4895 7.76025L3.10162 7.6365C3.25197 6.9843 3.51035 6.36183 3.86606 5.79488L2.81306 4.56581C2.74831 4.49033 2.71443 4.39319 2.71819 4.29381C2.72194 4.19444 2.76305 4.10013 2.83331 4.02975L4.02919 2.83388C4.09966 2.76362 4.194 2.72246 4.29343 2.71861C4.39287 2.71475 4.49011 2.74847 4.56581 2.81306L5.79488 3.86663C6.36207 3.51138 6.98446 3.25303 7.6365 3.10219L7.76025 1.49006C7.7679 1.39073 7.81277 1.29795 7.88587 1.23027C7.95898 1.16258 8.05494 1.12499 8.15456 1.125H9.846C10.0524 1.125 10.224 1.28419 10.2397 1.4895L10.2471 1.58344C9.84415 2.20144 9.61058 2.9144 9.56972 3.65101C9.52885 4.38761 9.68212 5.12204 10.0142 5.78081C9.55011 5.63469 9.05992 5.59063 8.57722 5.65166C8.09452 5.71268 7.63072 5.87736 7.21761 6.13439C6.8045 6.39142 6.45185 6.73473 6.18382 7.14079C5.9158 7.54686 5.73874 8.00607 5.66477 8.48696C5.59081 8.96785 5.6217 9.45904 5.75532 9.92688C5.88894 10.3947 6.12213 10.8281 6.43891 11.1974C6.75569 11.5667 7.14858 11.8631 7.59063 12.0664C8.03268 12.2696 8.51346 12.3749 9 12.375C9.83117 12.3753 10.6329 12.0672 11.25 11.5104V14.6166Z"
            fill={isActive ? "#1F4168" : "white"}
          />
          <path
            d="M15.187 6.63131V15.4688C15.187 15.8417 15.0389 16.1994 14.7752 16.4631C14.5114 16.7268 14.1537 16.875 13.7808 16.875C13.4078 16.875 13.0501 16.7268 12.7864 16.4631C12.5227 16.1994 12.3745 15.8417 12.3745 15.4688V6.63131C11.8753 6.37686 11.4546 5.99146 11.1576 5.51634C10.8605 5.04123 10.6982 4.49428 10.688 3.93403C10.6778 3.37377 10.8202 2.8213 11.0998 2.33572C11.3795 1.85013 11.7859 1.44972 12.2755 1.17731C12.3188 1.15369 12.3745 1.18744 12.3745 1.23694V4.5L13.7808 5.0625L15.187 4.5V1.23694C15.187 1.18744 15.2427 1.15369 15.286 1.17788C15.7759 1.45007 16.1825 1.85038 16.4623 2.33594C16.742 2.8215 16.8845 3.37402 16.8743 3.93433C16.8641 4.49463 16.7017 5.04162 16.4045 5.5167C16.1073 5.99179 15.6864 6.37708 15.187 6.63131Z"
            fill={isActive ? "#1F4168" : "white"}
          />
        </svg>
      ),

      url: "/service-list",
      id: 9,
      submenu: [],
    },
    {
      name: "Social Media",
      value: "social_media",
      className: activeClass(["/social-list", "/add-social", "/edit-social"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_4097_17940)">
            <path
              d="M11.8256 9.7266L13.6257 10.0839C13.6443 10.9668 14.3753 11.6675 15.2582 11.6489C16.1412 11.6302 16.8418 10.8993 16.8232 10.0163C16.8045 9.13339 16.0736 8.43272 15.1907 8.45137C14.8869 8.45779 14.5913 8.5506 14.3384 8.71895C14.0855 8.8873 13.8857 9.12422 13.7626 9.40196L11.9158 9.03541C11.9139 8.35959 11.6508 7.71066 11.1817 7.22421L13.5721 3.84744C14.5803 4.32684 15.7862 3.89813 16.2656 2.88989C16.745 1.88166 16.3163 0.67572 15.3081 0.196317C14.2998 -0.283086 13.0939 0.145629 12.6145 1.15386C12.2486 1.92352 12.4046 2.83999 13.0047 3.44515L10.6374 6.78928C9.54868 6.13543 8.14803 6.35518 7.31181 7.31094L4.204 4.89736C4.61193 4.11214 4.30611 3.14485 3.52089 2.73692C2.73566 2.32898 1.76838 2.6348 1.36044 3.42003C0.952508 4.20525 1.25833 5.17254 2.04355 5.58047C2.31381 5.72088 2.61849 5.78136 2.92188 5.75481C3.22528 5.72827 3.51483 5.6158 3.75659 5.43058L6.92435 7.89068C6.398 8.96603 6.66626 10.2613 7.57642 11.0391L5.65129 13.761C4.6321 13.1425 3.30444 13.4673 2.68593 14.4866C2.06742 15.5057 2.39224 16.8334 3.41147 17.4519C4.43066 18.0704 5.75832 17.7456 6.37683 16.7264C6.85749 15.9343 6.77912 14.9238 6.18199 14.2153L8.15907 11.4193C8.49349 11.5783 8.85776 11.6648 9.22797 11.6731C9.59817 11.6814 9.96595 11.6113 10.3072 11.4675L12.653 14.9328C11.9631 15.6623 11.9951 16.8129 12.7246 17.5029C13.454 18.1928 14.6047 18.1608 15.2946 17.4313C15.9845 16.7019 15.9525 15.5512 15.2231 14.8613C14.9601 14.6126 14.6289 14.448 14.2719 14.3887C13.9149 14.3293 13.5483 14.3779 13.219 14.5282L10.907 11.1127C11.3547 10.7619 11.677 10.2757 11.8256 9.7266Z"
              fill={isActive ? "#1F4168" : "white"} // Conditional color
            />
          </g>
          <defs>
            <clipPath id="clip0_4097_17940">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),

      url: "/social-list",
      id: 10,
      submenu: [],
    },
    {
      name: "Our Work",
      value: "our_works",
      className: activeClass(["/our-works"]),
      icon: (isActive) => (
        <svg
          width="22"
          height="22"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M64 256C64 150.16 150.16 64 256 64V48C141.28 48 48 141.28 48 256H64ZM464 256H448C448 361.84 361.84 448 256 448V464C370.72 464 464 370.72 464 256ZM272 48H288V64H272V48ZM224 448H240V464H224V448ZM299.04 208L238.4 283.36L211.76 256.88L200 268.56L233.2 301.6C234.8 303.12 236.88 304 239.04 304H239.52C241.84 303.84 244.08 302.72 245.52 300.88L311.92 218.32L298.96 208H299.04Z"
            fill={isActive ? "#1F4168" : "white"} // Conditional color
          />
          <path
            d="M416 256C416 167.76 344.24 96 256 96C167.76 96 96 167.76 96 256C96 344.24 167.76 416 256 416C344.24 416 416 344.24 416 256ZM160 256C160 203.04 203.04 160 256 160C308.96 160 352 203.04 352 256C352 308.96 308.96 352 256 352C203.04 352 160 308.96 160 256Z"
            fill={isActive ? "#1F4168" : "white"} // Conditional color
          />
        </svg>
      ),

      url: "/our-works",
      id: 11,
      submenu: [],
    },
    {
      name: "Settings",
      value: "settings",
      className: activeClass(["/admin-settings"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M16.4306 6.66C16.1024 6.61232 15.7892 6.49122 15.5142 6.3057C15.2393 6.12017 15.0098 5.87502 14.8427 5.58849C14.6757 5.30196 14.5754 4.98143 14.5494 4.65078C14.5234 4.32013 14.5723 3.98787 14.6925 3.67875C14.7689 3.47666 14.7802 3.25572 14.7247 3.04691C14.6692 2.8381 14.5498 2.65189 14.3831 2.51438C13.6474 1.89656 12.81 1.41123 11.9081 1.08C11.7028 1.00372 11.4786 0.994185 11.2675 1.05277C11.0564 1.11135 10.8692 1.23505 10.7325 1.40625C10.5268 1.66931 10.2639 1.88206 9.96369 2.02838C9.66351 2.1747 9.33396 2.25075 9.00001 2.25075C8.66607 2.25075 8.33651 2.1747 8.03633 2.02838C7.73615 1.88206 7.47323 1.66931 7.26751 1.40625C7.13084 1.23505 6.94362 1.11135 6.73253 1.05277C6.52144 0.994185 6.29724 1.00372 6.09189 1.08C5.2592 1.3858 4.48066 1.82254 3.78564 2.37375C3.61044 2.51244 3.48425 2.70358 3.42555 2.91918C3.36684 3.13478 3.3787 3.36351 3.45939 3.57188C3.58919 3.88918 3.64282 4.23248 3.61597 4.57425C3.58913 4.91602 3.48256 5.24674 3.30481 5.53989C3.12707 5.83303 2.88309 6.08044 2.59246 6.26226C2.30183 6.44408 1.97262 6.55526 1.63126 6.58688C1.40964 6.61057 1.20148 6.7048 1.03744 6.85568C0.87339 7.00656 0.762121 7.20613 0.720012 7.425C0.615273 7.94346 0.562512 8.47107 0.562512 9C0.561742 9.44281 0.597488 9.88494 0.669387 10.3219C0.705171 10.5478 0.81437 10.7556 0.980101 10.9132C1.14583 11.0708 1.35887 11.1694 1.58626 11.1938C1.93512 11.2265 2.27106 11.3423 2.56597 11.5315C2.86088 11.7208 3.10617 11.9779 3.28132 12.2813C3.45646 12.5848 3.55637 12.9258 3.57267 13.2758C3.58897 13.6259 3.52119 13.9747 3.37501 14.2931C3.27935 14.5003 3.25562 14.7334 3.30759 14.9556C3.35956 15.1777 3.48426 15.3762 3.66189 15.5194C4.3932 16.126 5.22258 16.6034 6.11439 16.9313C6.22843 16.9708 6.34808 16.9916 6.46876 16.9931C6.63423 16.9928 6.79721 16.9527 6.94401 16.8764C7.09082 16.8001 7.21719 16.6896 7.31251 16.5544C7.513 16.2623 7.78174 16.0235 8.09542 15.8588C8.4091 15.6942 8.75823 15.6085 9.11251 15.6094C9.45578 15.6098 9.7942 15.6904 10.1008 15.8447C10.4075 15.999 10.6739 16.2227 10.8788 16.4981C11.0151 16.6813 11.2081 16.8143 11.4279 16.8764C11.6476 16.9385 11.8818 16.9261 12.0938 16.8413C12.9092 16.5131 13.6684 16.0595 14.3438 15.4969C14.5134 15.3566 14.6342 15.1661 14.6888 14.9529C14.7434 14.7396 14.7289 14.5145 14.6475 14.31C14.5152 13.9968 14.4575 13.6571 14.479 13.3178C14.5005 12.9785 14.6005 12.6488 14.7713 12.3547C14.942 12.0607 15.1788 11.8104 15.4629 11.6236C15.7469 11.4367 16.0705 11.3185 16.4081 11.2781C16.6271 11.2479 16.8307 11.1487 16.9894 10.995C17.1482 10.8412 17.2539 10.641 17.2913 10.4231C17.3816 9.95395 17.4305 9.47774 17.4375 9C17.4376 8.49608 17.3905 7.99326 17.2969 7.49813C17.2589 7.28511 17.1548 7.08947 16.9993 6.93902C16.8438 6.78856 16.6448 6.69093 16.4306 6.66ZM11.8125 9C11.8125 9.55626 11.6476 10.1 11.3385 10.5625C11.0295 11.0251 10.5902 11.3855 10.0763 11.5984C9.56239 11.8113 8.99689 11.867 8.45132 11.7585C7.90575 11.6499 7.40461 11.3821 7.01127 10.9887C6.61794 10.5954 6.35007 10.0943 6.24155 9.54869C6.13303 9.00312 6.18873 8.43762 6.4016 7.9237C6.61447 7.40979 6.97496 6.97053 7.43747 6.66149C7.89998 6.35245 8.44375 6.1875 9.00001 6.1875C9.74593 6.1875 10.4613 6.48382 10.9887 7.01126C11.5162 7.53871 11.8125 8.25408 11.8125 9Z"
            fill={isActive ? "#1F4168" : "white"} // Conditional color
          />
        </svg>
      ),
      url: "/admin-settings",
      id: 12,
      submenu: [],
    },
    {
      name: "Clients Logos",
      value: "client_logos",
      className: activeClass(["/logo-list", "/add-logo"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3 5.25C3 4.25544 3.39509 3.30161 4.09835 2.59835C4.80161 1.89509 5.75544 1.5 6.75 1.5C7.74456 1.5 8.69839 1.89509 9.40165 2.59835C10.1049 3.30161 10.5 4.25544 10.5 5.25C10.5 6.24456 10.1049 7.19839 9.40165 7.90165C8.69839 8.60491 7.74456 9 6.75 9C5.75544 9 4.80161 8.60491 4.09835 7.90165C3.39509 7.19839 3 6.24456 3 5.25ZM10.9875 8.349C10.7955 8.6115 10.9245 9 11.25 9C12.2446 9 13.1984 8.60491 13.9017 7.90165C14.6049 7.19839 15 6.24456 15 5.25C15 4.25544 14.6049 3.30161 13.9017 2.59835C13.1984 1.89509 12.2446 1.5 11.25 1.5C10.9245 1.5 10.7955 1.88775 10.9875 2.151C11.625 3.0195 12 4.0905 12 5.25C12 6.4095 11.625 7.4805 10.9875 8.349ZM15 16.5C14.8011 16.5 14.6103 16.421 14.4697 16.2803C14.329 16.1397 14.25 15.9489 14.25 15.75V14.25C14.25 13.125 13.8795 12.0218 13.215 11.1225C13.0358 10.8795 13.1978 10.5 13.5 10.5C13.9925 10.5 14.4801 10.597 14.9351 10.7855C15.39 10.9739 15.8034 11.2501 16.1517 11.5984C16.4999 11.9466 16.7761 12.36 16.9645 12.8149C17.153 13.2699 17.25 13.7575 17.25 14.25V15.75C17.25 15.9489 17.171 16.1397 17.0303 16.2803C16.8897 16.421 16.6989 16.5 16.5 16.5H15ZM1.848 11.598C2.19629 11.2498 2.60976 10.9736 3.06479 10.7852C3.51982 10.5968 4.00751 10.4999 4.5 10.5H9C9.99456 10.5 10.9484 10.8951 11.6517 11.5984C12.3549 12.3016 12.75 13.2554 12.75 14.25V15.75C12.75 15.9489 12.671 16.1397 12.5303 16.2803C12.3897 16.421 12.1989 16.5 12 16.5H1.5C1.30109 16.5 1.11032 16.421 0.96967 16.2803C0.829018 16.1397 0.75 15.9489 0.75 15.75V14.25C0.750013 13.2556 1.14496 12.302 1.848 11.5988V11.598Z"
            fill={isActive ? "#1F4168" : "white"} // Conditional color
          />
        </svg>
      ),
      url: "/logo-list",
      id: 13,
      submenu: [],
    },
    {
      name: "Users",
      value: "users",
      className: activeClass(["/users", "/add-user", "/edit-service"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill={isActive ? "#1F4168" : "white"}
        >
          <path d="M480-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM192-192v-96q0-23 12.5-43.5T239-366q55-32 116.5-49T480-432q63 0 124.5 17T721-366q22 13 34.5 34t12.5 44v96H192Z" />
        </svg>
      ),
      url: "/users",
      id: 14,
      submenu: [],
    },
    {
      name: "Roles",
      value: "role",
      className: activeClass(["/role-permission", "/add-role"]),
      icon: (isActive) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill={isActive ? "#1F4168" : "white"} // Conditional color
        >
          <path d="M450-483q26-30 40-66t14-75q0-38-14-74t-40-67q8-2 15-2.5t15-.5q60 0 102 42t42 102q0 60-42 102t-102 42q-8 0-15.5-.5T450-483Zm198 291v-92q0-41-19-76.5T576-421q68 16 130 44t62 93v92H648Zm132-240v-84h-84v-72h84v-84h72v84h84v72h-84v84h-72Zm-492-48q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM0-192v-92q0-25 12.5-46.5T47-366q54-34 115.5-50T288-432q63 0 124 17t117 49q21 14 34 35.5t13 46.5v92H0Z" />
        </svg>
      ),
      url: "/role-permission",
      id: 15,
      submenu: [],
    },
  ];
  const role = String(localStorage.getItem("role") || "").toLowerCase();
  const isCaseStudyRole =
    role.includes("case study") ||
    role.includes("case-study") ||
    (permissionArray.length === 1 && permissionArray[0] === "portfolio");
  const filteredArray = isCaseStudyRole
    ? sidebarItems.filter((item) => item.value === "portfolio")
    : sidebarItems.filter(
        (item) =>
          item.value === "upload_file" ||
          permissionArray.includes(item.value.toLowerCase())
      );

  const renderMenuItem = (item, isActive) => {
    
    return (
      <li className="li-style" key={item.id}>
        <div
          className={item.className}
          onClick={item.value === "jobs" ? handleChildMenu : undefined}
        >
          <NavLink
            to={item.url || "#"}
            onClick={() => handleMenuActive(item.id)}
            className={({ isActive }) => (isActive ? "active-class" : "")}
            end
          >
            {item.icon(isActive)}
            {menuname ? <span className="menu-title">{item.name}</span> : null}
          </NavLink>
        </div>

        {item.submenu?.length > 0 && showChildMenu && (
          <ul style={{ listStyle: "none", paddingLeft: "1rem" }}>
            {item.submenu.map((subitem) => (
              <li
                key={subitem.id}
                className={menuname ? "li-style child-menu" : ""}
              >
                <div className={subitem.className} style={{ height: "47px" }} onClick={() => setActiveItem((prev) => (prev === subitem.id ? null : subitem.id))}
                >
                  <NavLink
                    to={subitem.url}
                 
                    
                    className= {activeItem === subitem.id  ? "active-class" : " "}
                    
                  >
                    {subitem.icon(subitem.id)}
                    {menuname ? (
                      <span className="menu-title">{subitem.name}</span>
                    ) : null}
                  </NavLink>
                </div>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <>
      <div id="sidebar" className="sidebar-fixed">
        <header>
          {menuname ? (
            <img
              src="../image/calidig-logo.svg"
              className="header-img"
              alt="no images"
              onClick={hideSideBar}
              loading="lazy"
            />
          ) : (
            <img
              src="../image/cropped-cali-favicon-192x192.png"
              alt="no images"
              width={35}
              height={35}
              onClick={showSideBar}
            />
          )}
        </header>
        <ul class="nav">
          {filteredArray.map((item) =>
            renderMenuItem(
              item,
              location.pathname === item.url ||
                item.submenu.some(
                  (subitem) => location.pathname === subitem.url
                )
            )
          )}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
